<template>
  <div class="agenda-table rounded-lg overflow-hidden border border-gray-100">
    <JdsDataTable
      :headers="tableHeader"
      :items="items"
      :loading="loading"
      :pagination="pagination"
      empty-text="Data tidak tersedia"
      @next-page="onPaginationChange('next-page', $event)"
      @previous-page="onPaginationChange('previous-page', $event)"
      @per-page-change="onPaginationChange('per-page-change', $event)"
      @page-change="onPaginationChange('page-change', $event)"
      @change:sort="onSortChange($event)"
    >
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.title="{item}">
        <p
          class="line-clamp-1"
          :title="item.title"
        >
          {{ item.title || '-' }}
        </p>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.is_pinned="{item}">
        <Restricted permission="event.set-pin">
          <p class="capitalize">
            {{ item.is_pinned ? 'Ya' : '-' }}
          </p>
        </Restricted>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.category="{item}">
        <p class="capitalize">
          {{ item.category || '-' }}
        </p>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.type="{item}">
        <p class="capitalize">
          {{ item.type || '-' }}
        </p>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.availability="{item}">
        <p class="capitalize">
          {{ item.availability?.toLowerCase() || '-' }}
        </p>
      </template>
      <!-- eslint-disable-next-line vue/valid-v-slot -->
      <template #item.action="{item}">
        <AgendaTableAction
          :item="item"
          @open-preview="$emit('open-preview', $event)"
          @delete="$emit('delete', $event)"
          @pin-agenda="$emit('pin-agenda', $event)"
          @unpin-agenda="$emit('unpin-agenda', $event)"
        />
      </template>
    </JdsDataTable>
  </div>
</template>

<script>
import AgendaTableAction from '@/components/AgendaV2/AgendaTableAction.vue';
import { AGENDA_TABLE_HEADER_V2 } from '@/common/constants';
import Restricted from '@/common/components/Restricted.vue';

export default {
  name: 'AgendaTable',
  components: {
    AgendaTableAction,
    Restricted,
  },
  props: {
    items: {
      type: Array,
      require: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
    meta: {
      type: Object,
      require: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalRows: 0,
        itemsPerPageOptions: [10, 20, 30, 40, 50],
      },
    };
  },
  computed: {
    tableHeader() {
      return this.$hasPermission('event.set-pin') ? AGENDA_TABLE_HEADER_V2 : AGENDA_TABLE_HEADER_V2.filter((item) => item.key !== 'is_pinned');
    },
  },
  watch: {
    meta: {
      handler() {
        this.pagination = {
          ...this.pagination,
          currentPage: this.meta?.current_page || 1,
          itemsPerPage: this.meta?.per_page || 10,
          totalRows: this.meta?.total_count || 0,
        };
      },
      immediate: true,
    },
  },
  methods: {
    onPaginationChange(action, value) {
      const paginationObj = { ...this.pagination };

      switch (action) {
        case 'next-page':
        case 'previous-page':
        case 'page-change':
          paginationObj.currentPage = value;
          break;

        case 'per-page-change':
          paginationObj.itemsPerPage = value;
          break;

        default:
          break;
      }

      this.pagination = { ...paginationObj };

      /**
       *  NOTE:
       *  `jds-pagination` emits `per-page-change` and `page-change` events
       *  whenever user changes per page value.
       *
       *  To avoid double fetch, we immediately stop this function on
       *  `per-page-change` event and let `page-change` event to
       *  fetch data from API
       */

      if (action === 'per-page-change') {
        return;
      }

      this.$emit('update:pagination', {
        page: this.pagination.currentPage,
        per_page: this.pagination.itemsPerPage,
      });
    },

    onSortChange(sort) {
      this.$emit('change:sort', {
        sort_by: Object.keys(sort)[0],
        sort_order: Object.values(sort)[0].toUpperCase(),
      });
    },
  },
};
</script>

<style>
/**
 * Override default jds-data-table style
 */
.agenda-table .jds-data-table {
  table-layout: fixed !important;
}

.agenda-table .jds-data-table thead tr th:nth-child(1) {
  width: 300px !important;
}

.agenda-table .jds-data-table thead tr th:nth-child(2) {
  width: 160px !important;
}

.agenda-table .jds-options .jds-options__filter {
  width: 100% !important;
  height: 48px !important;
}

.agenda-table .jds-options--filterable {
  min-width: 120px !important;
}
</style>
